import React from 'react'
export default function Auth() {
  return (
    <div>Auth
    </div>
  )
}
